<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
    <div class="rounded-t border-b-2 mb-0 p-6">
      <div class="text-center flex justify-between">
        <h6 class="text-primary text-lg font-bold"> {{'General.Doctors'|translate}} </h6>
  
      </div>
    </div>

    <div class="flex flex-wrap pt-6">
        <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-sm font-bold mb-2"> {{'General.Search'|translate}} </label>
              <input type="text" [(ngModel)]="searchInp.title" (keyup)="getDoctorsList(0)"
                    class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm w-full">
            </div>
        </div>
        <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-sm font-bold mb-2"> {{'General.Expertise'|translate}} </label>
              <select  [(ngModel)]="searchInp.medicalCategoryId" (change)="getDoctorsList(0)"
                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                    <option *ngFor="let cat of categoriesList" [value]="cat.id"> {{cat.name}} </option>
              </select>
            </div>
        </div>
        <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-sm font-bold mb-2"> {{'General.Status'|translate}} </label>
              <select  [(ngModel)]="searchInp.status" (change)="getDoctorsList(0)"
                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                    <option [value]="null"> --- </option>
                    <option [value]="doctorStatus.Approved"> تایید شده </option>
                    <option [value]="doctorStatus.NotApproved"> تایید نشده</option>
                    <option [value]="doctorStatus.Pending"> در انتظار تایید </option>
              </select>      
            </div>
        </div>
    </div>

    <div class="flex-auto p-4">
        <div class="relative w-full overflow-x-auto rounded-md">
            <table class="w-full bg-transparent border-collapse">
              <thead class="bg-primary text-white">
                <tr>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    {{'General.Picture'|translate}}
                </th>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold"  >
                     {{'General.Name'|translate}} 
                  </th>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold"  >
                    {{'General.FamilyName'|translate}} 
                  </th>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    {{'General.IDNumber'|translate}} 
                  </th>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    {{'General.Expertise'|translate}} 
                  </th>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold " >
                    {{'General.Province'|translate}}
                  </th>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    {{'General.Status'|translate}}                    
                  </th>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold"  >
                    {{'General.scheduling'|translate}}                    
                  </th>
                  <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold"  >
                    {{'General.DoctorInfo'|translate}}                    
                  </th>
                  <!-- <th
                    class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold" >
                    {{'General.Edit'|translate}}                    
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dr of doctorsList" class="border-b">
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                      <img [src]="dr.profilePic?apiService.api+dr.profilePic:'../../../../assets/img/thumb-profile1.svg.png'" 
                      class="h-12 w-12 bg-white rounded-full border" alt="..." onerror="this.onerror=null; this.src='../../../assets/img/thumb-profile1.svg.png';" />
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    {{dr.name}} 
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    {{dr.family}}
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    {{dr.meliCode}}
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    {{dr.medicalEspertiseName}}
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    فارس
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                    <select class="text-blueGray-600 border-gray-300 rounded text-sm w-full" 
                    [(ngModel)]="dr.status" (change)="drId=dr.id;drStatus=$event.target.value;modal.open()">
                      <option [value]="doctorStatus.Approved"> تایید شده </option>
                      <option [value]="doctorStatus.NotApproved"> تایید نشده </option>
                      <option [value]="doctorStatus.Pending"> در انتظار تایید </option>
                    </select>
                  </td>
                  <td
                    class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3"
                  >
                    <button class="bg-primary text-white rounded p-1 text-sm" type="button" [routerLink]="'/admin/doctor-calendar/'+dr.id" >
                    <img src="../../../../assets/img/icon/info-circle.svg" alt=""> </button>
                  </td>
                  <td
                    class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3"
                  >
                  <button class="bg-primary text-white rounded p-1 text-sm" type="button" [routerLink]="'/admin/doctor-info/'+dr.id" >
                     <img src="../../../../assets/img/icon/info-circle.svg" alt=""> </button>
                  </td>
                  <!-- <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
                  <button (click)="showToast()" class="bg-primary text-white rounded p-2 text-sm" type="button" >
                    <img src="../../../../assets/img/icon/edit.svg" alt=""> </button>
                  </td> -->
                </tr>
                
                
              </tbody>
            </table>
          </div>
          <div class="card flex justify-center">      
            <p-paginator
            dir="rtl"
            (onPageChange)="getDoctorsList($event.page)"
            [first]="first"
            [rows]="rows"
            [totalRecords]="collectionSize"
            [showCurrentPageReport]="true"
            [showPageLinks]="false"
            [showJumpToPageDropdown]="false"
            currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} رکورد" />
          </div>
    </div>
</div>
    
<p-toast dir="rtl"></p-toast>

<!-- MODAL SECTION -->

<app-modal #modal>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      تغییر وضعیت  
    </h3>
    <button class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" (click)="modal.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto">
    <p class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
      آیا برای تغییر وضعیت این کاربر اطمینان دارید؟
    </p>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between border-solid border-blueGray-200 rounded-b">
    <button class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150" type="button" (click)="modal.close()">
      انصراف
    </button>
    <button (click)="changeDrStatus()" class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150" type="button">
      تایید
    </button>
  </div>
</app-modal>